'use strict';

// Instance Methods
require('./after');
require('./cancel');
require('./debounce');
require('./delay');
require('./every');
require('./lazy');
require('./lock');
require('./memoize');
require('./once');
require('./partial');
require('./throttle');

module.exports = require('sugar-core');


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/function/index.js
// module id = 1159
// module chunks = 1